import { Button, Radio } from '@fagmobler/ui';
import { Popover } from '@headlessui/react';
import {
  ArrowsUpDownIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@heroicons/react/24/outline';
import { useSortBy } from 'react-instantsearch';
import { ALGOLIA_INDEX_NAME } from '@/lib/algolia/searchClient';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

export const SortingButtonWithPopover = ({
  className,
}: {
  className?: string;
}) => {
  const index = ALGOLIA_INDEX_NAME;
  const { options, refine, canRefine, initialIndex, currentRefinement } =
    useSortBy({
      items: [
        { label: 'Relevans', value: index },
        {
          label: 'Pris: Lavest til høyest',
          value: `${index}_price_asc`,
        },
        {
          label: 'Pris: Høyest til lavest',
          value: `${index}_price_desc`,
        },
      ],
    });

  return (
    <Popover title="Sorter etter" className={twMerge('relative', className)}>
      {({ open }) => (
        <>
          <Popover.Button as="div">
            <Button
              className={twMerge(
                clsx(
                  'whitespace-nowrap block p-2 w-full justify-between no-underline hover:bg-neutral-30 rounded-full',
                  {
                    'bg-neutral-30': open,
                  }
                )
              )}
              type="button"
              variant="link"
            >
              Sorter
              {open ? (
                <ChevronUpIcon className="h-4 w-4 ml-2" />
              ) : (
                <ChevronDownIcon className="h-4 w-4 ml-2" />
              )}
            </Button>
          </Popover.Button>
          <Popover.Panel className="absolute z-20 bg-neutral-0 shadow p-5 min-w-fit mt-2">
            {options.map((option) => {
              return (
                <Radio
                  label={option.label}
                  name={option.value}
                  value={option.value}
                  key={option.value}
                  checked={option.value === currentRefinement}
                  onChange={() => refine(option.value)}
                  className="mb-5 whitespace-nowrap"
                  disabled={!canRefine}
                />
              );
            })}
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
};

export default SortingButtonWithPopover;
